import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IOsaExecucaoFolhaTesteModel } from "./../../../../../models/osa-execucao-folha-teste-model";
import { OsaExecucaoFolhaTesteService } from "./../../../../../services/osa-execucao-folha-teste.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../../services/auth.service";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-cancelar',
  templateUrl: './osa-execucao-aba-folha-teste-cancelar.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-cancelar.component.scss']
})
export class OsaExecucaoAbaFolhaTesteCancelarComponent implements OnInit {

  public model: IOsaExecucaoFolhaTesteModel = {} as IOsaExecucaoFolhaTesteModel;
  public id: number = 0;

  constructor(
    public matDialog: MatDialog,
    public osaExecucaoFolhaTesteService: OsaExecucaoFolhaTesteService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteCancelarComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.id = data?.id;
  }

  ngOnInit(): void {
    this.obter(this.id);
  }

  public obter(id: number) {

    this.osaExecucaoFolhaTesteService
      .obterFolhaTestePorId(id)
      .then((res) => {
        if (res.sucesso) {

          this.model = res.dados;
          this.model.justificativaCanc = "";

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public cancelar() {

    if (!this.model.justificativaCanc || this.model.justificativaCanc === "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Informe a justificativa para cancelar!",
      });
      return;
    }

    const responsavelId = this.authService.usuario.id;
    this.model.responsavelIdCanc = responsavelId;
    this.model.status = 4;

    this.osaExecucaoFolhaTesteService
      .cancelarFolhaTeste(this.model)
      .then((res) => {
        if (res.sucesso) {

          this.dialogRef.close(true);

          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            text: res.mensagem.descricao,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      }).finally(() => {
      });


  }


  public fechar() {
    this.dialogRef.close(true);
  }

}

